// Recovered compiled webpack factory 41402. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      default: function () {
        return y;
      },
      handleClientScriptLoad: function () {
        return _;
      },
      initScriptLoader: function () {
        return m;
      },
    }));
  let n = r(28140),
    a = r(49417),
    o = r(95155),
    i = n._(r(47650)),
    s = a._(r(12115)),
    l = r(82073),
    u = r(94681),
    c = r(4853),
    f = r(29001),
    d = new Map(),
    p = new Set(),
    h = (e) => {
      let {
          src: t,
          id: r,
          onLoad: n = () => {},
          onReady: a = null,
          dangerouslySetInnerHTML: o,
          children: s = "",
          strategy: l = "afterInteractive",
          onError: c,
          stylesheets: f,
        } = e,
        h = r || t;
      if (h && p.has(h)) return;
      if (d.has(t)) {
        (p.add(h), d.get(t).then(n, c));
        return;
      }
      let _ = () => {
          (a && a(), p.add(h));
        },
        m = document.createElement("script"),
        g = new Promise((e, t) => {
          (m.addEventListener("load", function (t) {
            (e(), n && n.call(this, t), _());
          }),
            m.addEventListener("error", function (e) {
              t(e);
            }));
        }).catch(function (e) {
          c && c(e);
        });
      (o
        ? ((m.innerHTML = o.__html || ""), _())
        : s
          ? ((m.textContent = "string" == typeof s ? s : Array.isArray(s) ? s.join("") : ""), _())
          : t && ((m.src = t), d.set(t, g)),
        (0, u.setAttributesFromProps)(m, e),
        "worker" === l && m.setAttribute("type", "text/partytown"),
        m.setAttribute("data-nscript", l),
        f &&
          ((e) => {
            if (i.default.preinit)
              return e.forEach((e) => {
                i.default.preinit(e, { as: "style" });
              });
            {
              let t = document.head;
              e.forEach((e) => {
                let r = document.createElement("link");
                ((r.type = "text/css"), (r.rel = "stylesheet"), (r.href = e), t.appendChild(r));
              });
            }
          })(f),
        document.body.appendChild(m));
    };
  function _(e) {
    let { strategy: t = "afterInteractive" } = e;
    "lazyOnload" === t
      ? window.addEventListener("load", () => {
          (0, c.requestIdleCallback)(() => h(e));
        })
      : h(e);
  }
  function m(e) {
    (e.forEach(_),
      [
        ...document.querySelectorAll('[data-nscript="beforeInteractive"]'),
        ...document.querySelectorAll('[data-nscript="beforePageRender"]'),
      ].forEach((e) => {
        let t = e.id || e.getAttribute("src");
        p.add(t);
      }));
  }
  function g(e) {
    let {
        id: t,
        src: r = "",
        onLoad: n = () => {},
        onReady: a = null,
        strategy: u = "afterInteractive",
        onError: d,
        stylesheets: _,
        ...m
      } = e,
      {
        updateScripts: g,
        scripts: y,
        getIsSsr: v,
        appDir: b,
        nonce: E,
      } = (0, s.useContext)(l.HeadManagerContext);
    E = m.nonce || E;
    let R = (0, s.useRef)(!1);
    (0, s.useEffect)(() => {
      let e = t || r;
      R.current || (a && e && p.has(e) && a(), (R.current = !0));
    }, [a, t, r]);
    let P = (0, s.useRef)(!1);
    if (
      ((0, s.useEffect)(() => {
        if (!P.current) {
          if ("afterInteractive" === u) h(e);
          else
            "lazyOnload" === u &&
              ("complete" === document.readyState
                ? (0, c.requestIdleCallback)(() => h(e))
                : window.addEventListener("load", () => {
                    (0, c.requestIdleCallback)(() => h(e));
                  }));
          P.current = !0;
        }
      }, [e, u]),
      ("beforeInteractive" === u || "worker" === u) &&
        (g
          ? ((y[u] = (y[u] || []).concat([
              { id: t, src: r, onLoad: n, onReady: a, onError: d, ...m, nonce: E },
            ])),
            g(y))
          : v && v()
            ? p.add(t || r)
            : v && !v() && h({ ...e, nonce: E })),
      b)
    ) {
      if (
        (_ &&
          _.forEach((e) => {
            i.default.preinit(e, { as: "style" });
          }),
        "beforeInteractive" === u)
      )
        if (!r)
          return (
            m.dangerouslySetInnerHTML &&
              ((m.children = m.dangerouslySetInnerHTML.__html), delete m.dangerouslySetInnerHTML),
            (0, o.jsx)("script", {
              nonce: E,
              dangerouslySetInnerHTML: {
                __html:
                  "(self.__next_s=self.__next_s||[]).push(" +
                  (0, f.htmlEscapeJsonString)(JSON.stringify([0, { ...m, id: t }])) +
                  ")",
              },
            })
          );
        else
          return (
            i.default.preload(
              r,
              m.integrity
                ? { as: "script", integrity: m.integrity, nonce: E, crossOrigin: m.crossOrigin }
                : { as: "script", nonce: E, crossOrigin: m.crossOrigin },
            ),
            (0, o.jsx)("script", {
              nonce: E,
              dangerouslySetInnerHTML: {
                __html:
                  "(self.__next_s=self.__next_s||[]).push(" +
                  (0, f.htmlEscapeJsonString)(JSON.stringify([r, { ...m, id: t }])) +
                  ")",
              },
            })
          );
      "afterInteractive" === u &&
        r &&
        i.default.preload(
          r,
          m.integrity
            ? { as: "script", integrity: m.integrity, nonce: E, crossOrigin: m.crossOrigin }
            : { as: "script", nonce: E, crossOrigin: m.crossOrigin },
        );
    }
    return null;
  }
  Object.defineProperty(g, "__nextScript", { value: !0 });
  let y = g;
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
